import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id ACA42E0C-6EEF-47B6-8824-FD916C58E87F
 * name information-slab-symbol
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-slab-symbol.svg
 * tags
 * - Settings 
 */
export const InformationSlabSymbolIcon = createSvgIcon(<><path d="M13 9H11V7H13V9M14 15V17H10V15H11V13H10V11H13V15H14Z" /></>, 'InformationSlabSymbolIcon');
export default InformationSlabSymbolIcon